

export const environment = {
  production: false,
  baseUrl: 'https://uat-api.sarvm.ai',
  app_name: 'retailerApp',
  app_version_code: '101',
  unauthToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJhbm9ueW1vdXMiLCJzY29wZSI6WyJTWVNURU0iLCJob3VzZWhvbGRBcHAiXSwiaWF0IjoxNzU2OTgwMjE0LCJuYmYiOjE3NTY5ODAyMTQsImV4cCI6MTc4ODUxNjIxNCwiaXNzIjoic2Fydm06dW1zIiwic3ViIjoiYWNjZXNzVG9rZW4ifQ.RHO-8EDJBAV0VNA_6n88axA7QbDJ0dkZdGpyl-3PTgY',
  app_primary_color_code: '#10BAB2',
  app_name_test: 'SarvM Retailer',

  razorpay: {
    razorpay_key: 'rzp_live_V2pyoZIaso7wD2',
    razorpay_amount: '39900',
  },

  //flyyy
  flyy_partner_id: '825c65368746ff077a01',
  flyy_env: 'stage',
  flyy_theme: '#00a64f',
  flyy_segment_id: "Retailer",
  package_name: "com.sarvm.hh",

  firebaseConfig: {
    apiKey: "AIzaSyDHkUA7mBik6xzNt-zQ6hVY7_TUxKEUUwg",
    authDomain: "sarvm-ai.firebaseapp.com",
    projectId: "sarvm-ai",
    storageBucket: "sarvm-ai.firebasestorage.app",
    messagingSenderId: "134890018866",
    appId: "1:134890018866:web:dd893c11c33d24f713442b",
    measurementId: "G-B9H7BCM8EL",
    vapidKey: 'BFxXmtght7P6ZXw4L5i2yVD-Mnx-rd6SmRd1ECSYUVyvWBnbaqDmCV29JBmnJqLpeOKcao1GVedRWQSgFMGLEOk'
  },
  gMaps: {
    apiKey: 'AIzaSyB3mLu1YhKFrjGO5JnQtNYekBq47DOOTcc'
  },
  refferal: {
    ackPhonenumber: '08068862513',
  },
  enableServiceWorker: true,
};


